export default "__VITE_ASSET__CAvfgkcy__"